import { render, staticRenderFns } from "./DataAdministrationContactRequestLists.vue?vue&type=template&id=31ba5eb5&scoped=true"
import script from "./DataAdministrationContactRequestLists.vue?vue&type=script&lang=js"
export * from "./DataAdministrationContactRequestLists.vue?vue&type=script&lang=js"
import style0 from "./DataAdministrationContactRequestLists.vue?vue&type=style&index=0&id=31ba5eb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ba5eb5",
  null
  
)

export default component.exports